import {StructuredDataContent} from 'rlink-repos/content';

export class PromotionTile extends StructuredDataContent {
  static get contentIcon () {
    return 'square-o';
  }

  static defaultData () {
    return {
      priority: 1.0,
      tileParams: {openUrl: [''], openStoreForItem: ['']},
    }
  }
  get backgroundPath () {
    return this.data.get('backgroundPath');
  }

  get layoutType () {
    return this.data.get('layoutType');
  }

  get tileHref () {
    return this.data.get('tileHref');
  }

  get tileAction () {
    return this.data.get('tileAction');
  }

  get tileParams () {
    return this.data.get('tileParams');
  }

  get title () {
    return this.data.get('title');
  }

  get showSubtitle () {
    return this.data.get('showSubtitle');
  }

  get visibleFrom () {
    if (this.data.has('visibleFrom')) {
      return new Date(this.data.get('visibleFrom'));
    }

  }

  get displayLocations () {
    return this.data.get('displayLocations', []);
  }

  get visibleUntil () {
    if (this.data.has('visibleUntil')) {
      return new Date(this.data.get('visibleUntil'));
    }
  }

  get priority () {
    return this.data.get('priority');
  }

  get telemetryIdentifier () {
    return this.data.get('telemetryIdentifier');
  }

  get adminLabel () {
    return `[${this.layoutType || '?'}] ${(this.telemetryIdentifier && this.telemetryIdentifier.length > 0) ? this.telemetryIdentifier : '<new promo tile>'} (P=${this.priority})`;
  }

  get linkedContentPaths () {
    return [this.backgroundPath];
  }


}

PromotionTile.translatedAttributes = {
  title: {
    path: ['title'],
    description: 'An in-game news / promo item\'s title',
  },
};



// WEBPACK FOOTER //
// ./lib/rlink-promotiles/index.js